import React from "react";
import { css } from "@emotion/react";

import { BRICKS } from "@titelmedia/bricks";

const Gallery = (props) => {
  return (
    <div css={css`
      & > div > div {
        padding: 15px;
        max-height: calc(100% - 77px);
      }
    `}>
      <BRICKS.elements.Gallery {...props} />
    </div>
  );
};

export default Gallery;
